module.exports = {
  "debug": {
    "hello": "こんにちわ",
    "count": "数値は{{count}}です",
    "change_lang": "{{lang}}に変更",
    "changed": "変更しました",
  },
  "common": {
    "operator": "オペレーター"
  },
};